import { GQLDesignPageFragment } from '@theprintbar/graphql';
import { useIsMobile } from '@theprintbar/shared';
import { useCallback, useEffect, useState } from 'react';
import { MultiStepModal } from '../../../components';

interface TutorialWindowProps {
	tutorialKey?: string;
	designPage: GQLDesignPageFragment;
}

export function useTutorial({ tutorialKey, designPage }: TutorialWindowProps) {
	const [open, setOpen] = useState(false);
	const isMobile = useIsMobile(1024);

	useEffect(() => {
		if (!tutorialKey) return;
		//Check if the user has seen the tutorial
		const hasSeenTutorial = localStorage.getItem(tutorialKey);
		if (!hasSeenTutorial) {
			setOpen(true);
		}
	}, []);

	const closeTutorial = useCallback(() => {
		if (!tutorialKey) return;
		localStorage.setItem(tutorialKey, 'true');
		setOpen(false);
	}, [tutorialKey]);

	return {
		openTutorial: () => setOpen(true),
		tutorialWindow: (
			<MultiStepModal
				modalKey={isMobile ? 'mobile-tutorial' : 'tutorial'}
				open={open}
				onClose={closeTutorial}
				title="Designer Tutorial"
				steps={isMobile ? designPage.mobileTutorialSteps : designPage.tutorialSteps}
			></MultiStepModal>
		),
	};
}
